import { Component } from '@angular/core';
import { EstudianteService } from '../../services/estudiante.service';
import { Estudiante } from '../../models/estudiante.model';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-buscar-estudiante',
  templateUrl: './buscar-estudiante.component.html',
  styleUrls: ['./buscar-estudiante.component.css']
})
export class BuscarEstudianteComponent {
  private _nroLibreta: number | null = null;

  get nroLibreta(): number | null {
    return this._nroLibreta;
  }

  set nroLibreta(value: number | null) {
    this._nroLibreta = value;
    this.showRegisterPrompt = false; // Reset prompt when nroLibreta changes
  }

  estudiante: Estudiante | null = null;
  error: string | null = null;
  showRegisterPrompt: boolean = false;
  isNew: boolean = false;

  constructor(private estudianteService: EstudianteService) {}

  buscarEstudiante() {
    if (this.nroLibreta !== null) {
      this.estudianteService.getEstudiante(this.nroLibreta).subscribe(
        (data) => {
          if (data) {
            this.estudiante = data;
            this.error = null;
            this.showRegisterPrompt = false;
            this.isNew = false;
          } else {
            this.error = 'Estudiante no encontrado';
            this.estudiante = null;
            this.showRegisterPrompt = true;
          }
        },
        (err) => {
          if (err.status === 404) {
            this.error = 'Estudiante no encontrado';
            this.estudiante = null;
            this.showRegisterPrompt = true;
          } else {
            this.error = 'Error al buscar estudiante';
            this.estudiante = null;
          }
        }
      );
    }
  }

  registerNewEstudiante() {
    this.estudiante = new Estudiante(this.nroLibreta!, '', '');
    this.showRegisterPrompt = false;
    this.isNew = true;
    this.error = null;
  }

  handleCancelEdit(): void {
    this.estudiante = null;
    this.isNew = false;
  }
}
